import React from 'react';
import {  useParams } from 'react-router-dom';
import Sidebar from '../../components/Sidebar/Sidebar';
import './NewspaperDetail.scss';
import { useEffect } from 'react';
import { fetchNewOn } from '../../api/newsService';
import { useState } from 'react';
import { TitleComponent } from '../TitleDocument';
import BreadCrumb from '../BreadCrumb';
import DOMPurify from 'dompurify';

const NewOndetail = () => {
    const {newOnId} = useParams();
    const [postNewOn, setPostNewOn] = useState();
  const getData = async() => {
    let res = await fetchNewOn();
    if(res && res.data && res.data.data.lstNews){
      setPostNewOn(res.data.data.lstNews)
    }
  }
  useEffect(()=>{
    getData();
  },[])
  const sanitizeHTML = (html) => {
    return { __html: DOMPurify.sanitize(html) };
};
  return (
    <div className='news_detail container'>
      <div className='new_detail_content'>
        <div className='content'>
        {postNewOn && postNewOn.length > 0 &&
          (postNewOn
          .filter(detail => detail.id === parseInt(newOnId))
          .map(detail => (
            
            <div key={detail.id}>
            <div className='path '>
      
              <BreadCrumb caseCondition='case3'/>
        
            </div>
            <TitleComponent title={detail.title}/>
              <h1>{detail.title}</h1>
              <p>{detail.createDate}</p>
              <div dangerouslySetInnerHTML={sanitizeHTML(detail.content)} className='descrip'></div>
            </div>
          ))
  )}
        </div>
        <div className='sidebar_newdetail'><Sidebar/></div>
      </div>
    </div>
  )
}

export default NewOndetail;
